import { FetchArgs } from '@reduxjs/toolkit/query/react'
import { StringifyRequest } from '@/api/api'
import { FetchKolContentRequest } from '@/types/api/kols'
import { decamelizeKeys } from '@/utils/humps'
import removeNil from '@/utils/remove-nil'

const getFetchKolContentQuery = ({
  workspaceId,
  radar_uuid,
  dc_id_hashed,
  ...payload
}: FetchKolContentRequest): FetchArgs => {
  const stringifyRequest: StringifyRequest = {
    stringify: true,
    arrayFormat: 'bracket',
  }
  const params = removeNil({
    ...payload,
    ...decamelizeKeys(stringifyRequest),
    radar_uuid,
    dc_id_hashed,
  })
  return {
    url: `/v3/workspaces/${workspaceId}/kol/content`,
    params,
  }
}

export default getFetchKolContentQuery
